import * as React from 'react';
import { SVGProps } from 'react';

const ChartIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 41">
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M15.556 35.5H6.668V22.167h8.888" />
      <path d="M15.555 5.5h8.888v30h-8.888v-30ZM24.445 13.833h8.889V35.5h-8.889" />
    </g>
  </svg>
);
export default ChartIcon;
